<template>
	<div class="container">
		<b-container class="pb-5">
			<div class="bodyOrigen">

				<md-table v-if="tableVisible" v-model="datosOrigen" md-card md-fixed-header :class="{
					'balance-table': true,
					'principal-table': true,
					'with-detail': fgl_detalle
				}" :key="tableKey">

					<md-table-toolbar>
						<div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
							<div style="flex: 1; text-align: center;">
								<h1 class="md-title"><b><i>{{ f_titulo() }}</i></b></h1>
							</div>
						</div>
					</md-table-toolbar>

					<md-table-row slot="md-table-row" slot-scope="{ item }" :class="{ 'clickable-row': true }"
						@click="f_muestra(item)">
						<md-table-cell :md-label="labels.cuenta" class="text-center border">
							{{ item.cuenta }}
						</md-table-cell>
						<md-table-cell :md-label="labels.descripcion" class="text-left border">
							{{ item.descripcion }}
						</md-table-cell>
						<md-table-cell v-if="fgl_detalle" :md-label="labels.saldo_actual" class="text-right border">
							{{ formato(item.saldo_actual) }}
						</md-table-cell>
						<md-table-cell v-if="fgl_detalle" :md-label="labels.funcional1" class="text-right border">
							{{ formato(item.funcional1) }}
						</md-table-cell>
						<md-table-cell v-if="fgl_detalle" :md-label="labels.funcional2" class="text-right border">
							{{ formato(item.funcional2) }}
						</md-table-cell>
						<md-table-cell v-if="fgl_detalle" :md-label="labels.ajuste_actual" class="text-right border">
							{{ formato(item.ajuste_actual) }}
						</md-table-cell>
						<md-table-cell :md-label="labels.ajuste_funcional1" class="text-right border">
							{{ formato(item.ajuste_funcional1) }}
						</md-table-cell>
					</md-table-row>
				</md-table>

				<md-dialog-actions class="action-buttons-sobrios">
					<div class="button-group-sobrio">
						<md-button class="md-raised md-primary action-btn-sobrio" @click="toggleDetalle()">
							Detalle
						</md-button>
						<md-button class="md-raised md-primary action-btn-sobrio" @click="f_mostrar_diferencia()">
							<md-icon>calculate</md-icon>
							{{ labels.balance }}
						</md-button>

						<md-button v-if="infoOpcion == 2 && infoTipoAjuste != 1" class="md-raised action-btn-sobrio"
							@click="f_contraAjuste()">
							<md-icon>tune</md-icon>
							{{ labels.ajustar }}
						</md-button>

						<md-button v-if="infoOpcion == 2" class="md-raised md-primary action-btn-sobrio"
							@click="f_ajustar_todo()">
							<md-icon>playlist_add_check</md-icon>
							Ajustar Todo
						</md-button>
					</div>

					<div v-if="mostrar" class="diferencias-sobrias">
						<div class="diferencias-header-sobrio">
							<md-icon class="header-icon">calculate</md-icon>
							<span class="header-title">Diferencias por Ajustar</span>
						</div>

						<div class="diferencias-grid-sobrio">
							<div v-if="valor_ajustar_funcional1 != 0" class="diferencia-item-sobrio">
								<span class="diferencia-label">{{ labels.funcional1 }}</span>
								<span class="diferencia-valor" :class="{ 'negativo': valor_ajustar_funcional1 < 0 }">
									{{ formato(valor_ajustar_funcional1) }}
								</span>
							</div>
							<!--
							<div v-if="valor_ajustar_funcional2 != 0" class="diferencia-item-sobrio">
								<span class="diferencia-label">{{ labels.funcional2 }}</span>
								<span class="diferencia-valor" :class="{ 'negativo': valor_ajustar_funcional2 < 0 }">
									{{ formato(valor_ajustar_funcional2) }}
								</span>
							</div>
							<div v-if="valor_ajustar_promedio1 != 0" class="diferencia-item-sobrio">
								<span class="diferencia-label">{{ labels.promedio1 }}</span>
								<span class="diferencia-valor" :class="{ 'negativo': valor_ajustar_promedio1 < 0 }">
									{{ formato(valor_ajustar_promedio1) }}
								</span>
							</div>
							<div v-if="valor_ajustar_promedio2 != 0" class="diferencia-item-sobrio">
								<span class="diferencia-label">{{ labels.promedio2 }}</span>
								<span class="diferencia-valor" :class="{ 'negativo': valor_ajustar_promedio2 < 0 }">
									{{ formato(valor_ajustar_promedio2) }}
								</span>
							</div>
							<div v-if="valor_ajustar_interna1 != 0" class="diferencia-item-sobrio">
								<span class="diferencia-label">{{ labels.interna1 }}</span>
								<span class="diferencia-valor" :class="{ 'negativo': valor_ajustar_interna1 < 0 }">
									{{ formato(valor_ajustar_interna1) }}
								</span>
							</div>
							<div v-if="valor_ajustar_interna2 != 0" class="diferencia-item-sobrio">
								<span class="diferencia-label">{{ labels.interna2 }}</span>
								<span class="diferencia-valor" :class="{ 'negativo': valor_ajustar_interna2 < 0 }">
									{{ formato(valor_ajustar_interna2) }}
								</span>
							</div>
-->
						</div>
					</div>
				</md-dialog-actions>
			</div>

			<!-- Modal para edición manual (MANTENIDO ORIGINAL) -->
			<md-dialog :md-active.sync="showDialogEdit">
				<md-dialog-title class="text-center">
					<h3><b><i>{{ f_titulo() }}<br>{{ labels.origen }}</i></b></h3>
				</md-dialog-title>
				<md-dialog-content>
					<b-form-group @submit.prevent="editaInfoBalance">
						<b-row>
							<h4><b-col cols="2"><b><i>{{ labels.cuenta }}</i></b></b-col></h4>
							<b-col cols="2">
								<h4>{{ formEdit.cuenta }}</h4>
							</b-col>
							<b-col cols="8">
								<h4>{{ formEdit.descripcion }}</h4>
							</b-col>
						</b-row>
						<b-row><b-col cols="2">
								<h4><b><i>{{ labels.saldo_actual }}</i></b></h4>
							</b-col>
							<b-col cols="2"></b-col>
							<b-col cols="8">
								<h4>{{ formato(formEdit.saldo_actual) }}</h4>
							</b-col></b-row>

						<b-row><b-col cols="4">
								<h4><b><i>{{ labels.funcional1 }}</i></b></h4>
							</b-col>
							<b-col cols="4">
								<h4><b><i>{{ labels.promedio1 }}</i></b></h4>
							</b-col>
							<b-col cols="4">
								<h4><b><i>{{ labels.interna1 }}</i></b></h4>
							</b-col></b-row>
						<b-row><b-col cols="4" class="border">
								<h4>{{ formato(formEdit.funcional1) }}</h4>
							</b-col>
							<b-col cols="4" class="border">
								<h4>{{ formato(formEdit.promedio1) }}</h4>
							</b-col>
							<b-col cols="4" class="border">
								<h4>{{ formato(formEdit.interna1) }}</h4>
							</b-col></b-row>

						<b-row><b-col cols="4">
								<h4><b><i>{{ labels.funcional2 }}</i></b></h4>
							</b-col>
							<b-col cols="4">
								<h4><b><i>{{ labels.promedio2 }}</i></b></h4>
							</b-col>
							<b-col cols="4">
								<h4><b><i>{{ labels.interna2 }}</i></b></h4>
							</b-col></b-row>
						<b-row><b-col cols="4" class="border">
								<h4>{{ formato(formEdit.funcional2) }}</h4>
							</b-col>
							<b-col cols="4" class="border">
								<h4>{{ formato(formEdit.promedio2) }}</h4>
							</b-col>
							<b-col cols="4" class="border">
								<h4>{{ formato(formEdit.interna2) }}</h4>
							</b-col></b-row>


						<b-row><b-col cols="3">
								<h4><b><i>{{ labels.ajuste_actual }}</i></b></h4>
							</b-col>
							<b-col cols="1"></b-col>
							<b-col v-if="!eliminar" cols="8" class="col-lg-3 border">
								<md-field> <md-input v-model="v_ajuste_actual" type="text"
										v-on:blur="f_ajuste_actual"></md-input> </md-field>
							</b-col>
							<b-col v-if="eliminar" cols="8" class="col-lg-3 border">
								<md-field> <md-input v-model="v_ajuste_actual" type="text" readonly></md-input>
								</md-field>
							</b-col>
						</b-row>

						<b-row><b-col cols="4">
								<h4><b><i>{{ labels.ajuste_funcional1 }}</i></b></h4>
							</b-col>
							<b-col cols="4">
								<h4><b><i>{{ labels.ajuste_promedio1 }}</i></b></h4>
							</b-col>
							<b-col cols="4">
								<h4><b><i>{{ labels.ajuste_interna1 }}</i></b></h4>
							</b-col></b-row>
						<b-row>
							<b-col v-if="!eliminar" cols="4" class="col-lg-3 border">
								<md-field> <md-input v-model="v_ajuste_funcional1" type="text"></md-input> </md-field>
							</b-col>
							<b-col v-if="eliminar" cols="4" class="border">
								<md-field> <md-input v-model="v_ajuste_funcional1" type="text" readonly></md-input>
								</md-field>
							</b-col>
							<b-col v-if="!eliminar" cols="4" class="border">
								<md-field> <md-input v-model="v_ajuste_promedio1" type="text"></md-input> </md-field>
							</b-col>
							<b-col v-if="eliminar" cols="4" class="border">
								<md-field> <md-input v-model="v_ajuste_promedio1" type="text" readonly></md-input>
								</md-field>
							</b-col>
							<b-col v-if="!eliminar" cols="4" class="border">
								<md-field> <md-input v-model="v_ajuste_interna1" type="text"></md-input> </md-field>
							</b-col>
							<b-col v-if="eliminar" cols="4" class="border">
								<md-field><md-input v-model="v_ajuste_interna1" type="text" readonly></md-input>
								</md-field>
							</b-col>
						</b-row>
						<b-row><b-col cols="4">
								<h4><b><i>{{ labels.ajuste_funcional2 }}</i></b></h4>
							</b-col>
							<b-col cols="4">
								<h4><b><i>{{ labels.ajuste_promedio2 }}</i></b></h4>
							</b-col>
							<b-col cols="4">
								<h4><b><i>{{ labels.ajuste_interna2 }}</i></b></h4>
							</b-col></b-row>
						<b-row>
							<b-col v-if="!eliminar" cols="4" class="col-lg-3 border">
								<md-field> <md-input v-model="v_ajuste_funcional2" type="text"></md-input> </md-field>
							</b-col>
							<b-col v-if="eliminar" cols="4" class="border">
								<md-field> <md-input v-model="v_ajuste_funcional2" type="text" readonly></md-input>
								</md-field>
							</b-col>
							<b-col v-if="!eliminar" cols="4" class="border">
								<md-field> <md-input v-model="v_ajuste_promedio2" type="text"></md-input> </md-field>
							</b-col>
							<b-col v-if="eliminar" cols="4" class="border">
								<md-field> <md-input v-model="v_ajuste_promedio2" type="text" readonly></md-input>
								</md-field>
							</b-col>
							<b-col v-if="!eliminar" cols="4" class="border">
								<md-field> <md-input v-model="v_ajuste_interna2" type="text"></md-input> </md-field>
							</b-col>
							<b-col v-if="eliminar" cols="4" class="border">
								<md-field><md-input v-model="v_ajuste_interna2" type="text" readonly></md-input>
								</md-field>
							</b-col>
						</b-row>

					</b-form-group>
					<md-dialog-actions>
						<md-button v-if="!eliminar" class="md-primary" @click="f_restaurar()">Restaurar</md-button>
						<md-button v-if="!eliminar" class="md-primary" @click="grabeAjuste()">Guardar</md-button>
						<md-button v-if="eliminar" class="md-primary" @click="elimineAjuste()">Eliminar</md-button>
						<md-button class="md-accent" @click="showDialogEdit = false">Cerrar</md-button>
					</md-dialog-actions>
				</md-dialog-content>
			</md-dialog>

			<md-dialog :md-active.sync="showContraAjuste" class="modal-sobrio" md-centered>
				<md-dialog-title class="modal-title-sobrio text-center">
					<div class="title-content justify-center">
						<md-icon>tune</md-icon>
						<span>{{ f1_titulo() }}</span>
					</div>
				</md-dialog-title>

				<md-dialog-content class="modal-content-sobrio">
					<!-- Selector de empresa -->
					<div class="form-section">
						<h4 class="section-label">Seleccione dónde aplicar el ajuste:</h4>
						<div class="radio-group">
							<md-radio v-model="formAjuste.origen" :value="true" class="radio-option"
								@change="uncheck(1)">
								<div class="option-content">
									<span class="empresa-nombre">{{ infoEmpresa }}</span>
									<span class="empresa-tipo">(Origen - Distribuir en {{ cuentasOrigen }}
										cuentas)</span>
								</div>
							</md-radio>

							<md-radio v-model="formAjuste.destino" :value="true" class="radio-option"
								@change="uncheck(2)">
								<div class="option-content">
									<span class="empresa-nombre">{{ infoEmpresa1 }}</span>
									<span class="empresa-tipo">(Destino - 1 cuenta)</span>
								</div>
							</md-radio>
						</div>
					</div>

					<!-- Resumen de ajuste automático -->
					<div class="form-section" v-if="showSummary">
						<h4 class="section-label">Resumen del Ajuste Automático</h4>
						<div class="summary-sobrio">
							<div class="summary-item">
								<md-icon class="summary-icon">info</md-icon>
								<span class="summary-text">Se distribuirá automáticamente para igualar los
									totales</span>
							</div>
							<div class="summary-item">
								<md-icon class="summary-icon">calculate</md-icon>
								<span class="summary-text">Diferencia actual: {{ formato(diferenciaTotal) }}</span>
							</div>
						</div>
					</div>
				</md-dialog-content>

				<md-dialog-actions class="modal-actions-sobrio">
					<md-button class="md-primary btn-sobrio" @click="aplicarAjusteAutomatico()">
						<md-icon>check</md-icon>
						Aplicar Ajuste Automático
					</md-button>
					<md-button class="btn-sobrio-secondary" @click="showContraAjuste = false">
						<md-icon>close</md-icon>
						Cancelar
					</md-button>
				</md-dialog-actions>
			</md-dialog>
		</b-container>
	</div>
</template>

<script>
import Balance from "@/services/BalanceNiif"

export default {
	name: "EliminaOrigen",

	data: () => ({
		optOrigen: [],
		showDialogEdit: false,
		showContraAjuste: false,
		formEdit: {},
		formAjuste: {
			origen: false,
			destino: false,
			descripcion: "AJUSTE CONCILIACION"
		},
		tableVisible: true,
		tableKey: 0,
		datosOrigen: [],
		cuentasOrigen: 0,
		diferenciaTotal: 0,
		showSummary: false,
		totalAjusteOrigenActual: 0,
		totalAjusteDestinoActual: 0,
		v_ajuste_actual: '',
		v_ajuste_funcional1: '',
		v_ajuste_promedio1: '',
		v_ajuste_interna1: '',
		v_ajuste_funcional2: '',
		v_ajuste_promedio2: '',
		v_ajuste_interna2: '',
		porcentaje: 1,
		vc_cuenta: "99999999",
		vc_descripcion: "Cuenta controlante",
		vc_saldo_actual: 0,
		vc_funcional1: 0,
		vc_ajuste_actual: 0,
		vc_ajuste_funcional1: 0,
		valor_ajustar_actual: 0,
		valor_ajustar_funcional1: 0,
		valor_ajustar_promedio1: 0,
		valor_ajustar_interna1: 0,
		valor_ajustar_funcional2: 0,
		valor_ajustar_promedio2: 0,
		valor_ajustar_interna2: 0,
		mostrar: false,
		eliminar: false,
		fgl_detalle: false,
	}),
	props: ['infocodReporte',
		'infoOrigen',
		'infoOpcion',
		'infoEmpresa',
		'infoIdCompania',
		'infoEmpresa1',
		'infoIdCompania1',
		'infoTipoAjuste',
		'infoTipo',
		'infoVigencia',
		'infoSecuencia',
	],
	
	computed: {
		labels() {
			if (this.$store.state._language == "es-ES") {
				return {
					origen: "Cuenta Controlante",
					cuenta: "Cuenta",
					descripcion: "Descripcion",
					saldo_actual: "Saldo",
					funcional1: "Funcional",
					funcional2: "Funcional2",
					promedio1: "Promedio",
					promedio2: "Promedio2",
					interna1: "Interna",
					interna2: "Interna2",
					ajuste_actual: "Ajuste Saldo",
					ajuste_funcional1: "Ajuste Funcional",
					ajuste_promedio1: "Ajuste Promedio",
					ajuste_interna1: "Ajuste Interna",
					ajuste_funcional2: "Ajuste Funcional2",
					ajuste_promedio2: "Ajuste Promedio2",
					ajuste_interna2: "Ajuste Interna2",
					opcion: "Modificar",
					ajustar: "Ajustar",
					balance: "Diferencia",
					ajuste: "Ajuste de Consolidacion",
				}
			} else {
				return {
					origen: "Controling Account",
					cuenta: "Account",
					descripcion: "Description",
					saldo_actual: "Saldo",
					funcional1: "Funcional",
					funcional2: "Funcional2",
					promedio1: "Average",
					promedio2: "Average2",
					interna1: "Internal",
					interna2: "Internal2",
					ajuste_actual: "Balance Adjustment",
					ajuste_funcional1: "Funcional Adjustment",
					ajuste_promedio1: "Average Adjustment",
					ajuste_interna1: "Internal Adjustment",
					ajuste_funcional2: "Funcional Adjustment2",
					ajuste_promedio2: "Average Adjustment2",
					ajuste_interna2: "Internal Adjustment2",
					opcion: "Modify",
					ajustar: "Adjust",
					balance: "Diferenc",
					ajuste: "Consolidation Adjustment",
				}
			}
		}
	},
	methods: {

		f_titulo() {
			let tipo_ajuste = ""
			switch (this.infoTipoAjuste) {
				case 1: tipo_ajuste = "Interes No Controlante"; break;
				case 2: tipo_ajuste = "Eliminacion en Inversion"; break;
				case 3: tipo_ajuste = "Eliminacion Saldos Reciprocos"; break;
				case 4: tipo_ajuste = "Ajuste del combinado"; break;
				default: tipo_ajuste = "Tipo sin identificar"; break;
			}
			let titulo = this.infoEmpresa + " " + tipo_ajuste
			return titulo
		},
		f1_titulo() {
			let titulo = this.labels.ajuste
			return titulo
		},
		formato(numero) {
			return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(numero)
		},
		async f_muestra(r_origen) {
			if (this.infoOpcion == 2) {
				this.mostrar = false;
				this.porcentaje = 1;
				if (r_origen.saldo_actual != 0) {
					this.porcentaje = r_origen.funcional1 / r_origen.saldo_actual;
				} else {
					if (r_origen.ajuste_actual != 0)
						this.porcentaje = r_origen.ajuste_funcional1 / r_origen.ajuste_actual;
				}

				this.eliminar = false;
				if (r_origen.origen == "C") {
					this.eliminar = true;
				}

				// VERIFICAR Y ACTUALIZAR VALORES 0 A 1 ANTES DE ABRIR EL MODAL
				try {
					const respuesta = await Balance.verificarYActualizarValoresCero({
						vigencia: r_origen.vigencia,
						secuencia: r_origen.secuencia,
						id_compania: r_origen.id_compania,
						tipo_ajuste: r_origen.tipo_ajuste,
						cuenta: r_origen.cuenta,
						tabla: "O" // Para origen
					});

					if (respuesta.data && respuesta.data.item) {
						// Usar los datos actualizados del backend
						this.formEdit = { ...respuesta.data.item };
					} else {
						this.formEdit = { ...r_origen };
					}
				} catch (error) {
					console.error("Error al actualizar valores:", error);
					this.formEdit = { ...r_origen };
				}

				this.v_ajuste_actual = this.formEdit.ajuste_actual;
				this.v_ajuste_funcional1 = this.formEdit.ajuste_funcional1;
				this.v_ajuste_promedio1 = this.formEdit.ajuste_promedio1;
				this.v_ajuste_interna1 = this.formEdit.ajuste_interna1;
				this.v_ajuste_funcional2 = this.formEdit.ajuste_funcional2;
				this.v_ajuste_promedio2 = this.formEdit.ajuste_promedio2;
				this.v_ajuste_interna2 = this.formEdit.ajuste_interna2;
				this.showDialogEdit = true;
			}
		},

		// Añadir estos mismos métodos nuevos que añadimos en Destino
		async verificarYActualizarValoresCero(item, tipo) {
			// Lista de campos a verificar
			const camposAverificar = [
				'saldo_actual', 'funcional1', 'funcional2',
				'promedio1', 'promedio2', 'interna1', 'interna2',
				'ajuste_actual', 'ajuste_funcional1', 'ajuste_funcional2',
				'ajuste_promedio1', 'ajuste_promedio2', 'ajuste_interna1', 'ajuste_interna2'
			];

			// Verificar si hay algún campo en 0
			let hayCeros = false;
			for (const campo of camposAverificar) {
				if (item[campo] === 0 || item[campo] === "0") {
					hayCeros = true;
					break;
				}
			}

			if (!hayCeros) {
				return false; // No hay valores en 0, no hacer nada
			}

			// Crear un objeto con los valores actualizados (cambiar 0 por 1)
			const valoresActualizados = { ...item };
			for (const campo of camposAverificar) {
				if (valoresActualizados[campo] === 0 || valoresActualizados[campo] === "0") {
					valoresActualizados[campo] = 1;
				}
			}

			// Llamar al servicio para actualizar en la base de datos
			try {
				await Balance.actualizarValoresCero(tipo, valoresActualizados);
				this.$toast.info("Se han actualizado valores de 0 a 1 para evitar divisiones por cero");
				return true;
			} catch (error) {
				this.$toast.error("Error al actualizar valores");
				console.error("Error:", error);
				return false;
			}
		},

		async obtenerItemActualizado(itemOriginal) {
			try {
				const respuesta = await Balance.obtenerItemActualizado(
					this.infoVigencia,
					this.infoSecuencia,
					itemOriginal.cuenta,
					"O" // Origen
				);

				if (respuesta.data && respuesta.data.item) {
					return respuesta.data.item;
				}
				return null;
			} catch (error) {
				console.error("Error al obtener item actualizado:", error);
				return null;
			}
		},
		f_ajuste_actual() {
			if (this.v_ajuste_actual == "0") {
				this.v_ajuste_funcional1 = 0
				this.v_ajuste_promedio1 = 0
				this.v_ajuste_interna1 = 0
				this.v_ajuste_funcional2 = 0
				this.v_ajuste_promedio2 = 0
				this.v_ajuste_interna2 = 0
			} else {
				let porcentaje = 1.00
				if (parseFloat(this.formEdit.saldo_actual) != 0) {
					porcentaje = parseFloat(this.v_ajuste_actual) / parseFloat(this.formEdit.saldo_actual)
					/*				porcentaje = Math.abs(porcentaje) */
					this.v_ajuste_actual = Math.round(this.formEdit.saldo_actual * porcentaje * 100) / 100
					this.v_ajuste_funcional1 = Math.round(this.formEdit.funcional1 * porcentaje * 100) / 100
					this.v_ajuste_promedio1 = Math.round(this.formEdit.promedio1 * porcentaje * 100) / 100
					this.v_ajuste_interna1 = Math.round(this.formEdit.interna1 * porcentaje * 100) / 100
					this.v_ajuste_funcional2 = Math.round(this.formEdit.funcional2 * porcentaje * 100) / 100
					this.v_ajuste_promedio2 = Math.round(this.formEdit.promedio2 * porcentaje * 100) / 100
					this.v_ajuste_interna2 = Math.round(this.formEdit.interna2 * porcentaje * 100) / 100
				} else {
					this.v_ajuste_funcional1 = this.v_ajuste_actual
					this.v_ajuste_promedio1 = this.v_ajuste_actual
					this.v_ajuste_interna1 = this.v_ajuste_actual
					this.v_ajuste_funcional2 = this.v_ajuste_actual
					this.v_ajuste_promedio2 = this.v_ajuste_actual
					this.v_ajuste_interna2 = this.v_ajuste_actual
				}
			}

		},
		f_restaurar() {
			this.v_ajuste_actual = -this.formEdit.saldo_actual
			this.v_ajuste_funcional1 = -this.formEdit.funcional1
			this.v_ajuste_promedio1 = -this.formEdit.promedio1
			this.v_ajuste_interna1 = -this.formEdit.interna1
			this.v_ajuste_funcional2 = -this.formEdit.funcional2
			this.v_ajuste_promedio2 = -this.formEdit.promedio2
			this.v_ajuste_interna2 = -this.formEdit.interna2
			this.formEdit.ajuste_actual = this.v_ajuste_actual
			this.formEdit.ajuste_funcional1 = this.v_ajuste_funcional1
			this.formEdit.ajuste_promedio1 = this.v_ajuste_promedio1
			this.formEdit.ajuste_interna1 = this.v_ajuste_interna1
			this.formEdit.ajuste_funcional2 = this.v_ajuste_funcional2
			this.formEdit.ajuste_promedio2 = this.v_ajuste_promedio2
			this.formEdit.ajuste_interna2 = this.v_ajuste_interna2
		},

		f_ajustar_todo() {
			if (!this.infoOrigen || this.infoOrigen.length === 0) {
				this.$toast.error("No hay registros para ajustar");
				return;
			}

			const confirmar = confirm(`¿Ajustar todos los registros?\nEsta acción aplicará el ajuste automático a ${this.infoOrigen.length} registros`);

			if (confirmar) {
				this.ejecutarAjusteTotal();
			}
		},

		async ejecutarAjusteTotal() {
			let registrosAjustados = 0;
			let errores = 0;

			// Procesar cada registro
			for (const item of this.infoOrigen) {
				if (item.origen !== "C") { // Solo ajustar registros que no sean contra-ajustes
					try {
						// Calcular los valores de ajuste automáticamente (cambiar signo)
						const ajusteActual = -item.saldo_actual;
						const ajusteFuncional1 = -item.funcional1;
						const ajustePromedio1 = -item.promedio1;
						const ajusteInterna1 = -item.interna1;
						const ajusteFuncional2 = -item.funcional2;
						const ajustePromedio2 = -item.promedio2;
						const ajusteInterna2 = -item.interna2;

						// Preparar el objeto con los ajustes
						const registroAjustado = {
							...item,
							ajuste_actual: ajusteActual,
							ajuste_funcional1: ajusteFuncional1,
							ajuste_promedio1: ajustePromedio1,
							ajuste_interna1: ajusteInterna1,
							ajuste_funcional2: ajusteFuncional2,
							ajuste_promedio2: ajustePromedio2,
							ajuste_interna2: ajusteInterna2
						};

						// Guardar el ajuste
						await Balance.grabeAjuste("O", registroAjustado);
						registrosAjustados++;

						// Actualizar el item localmente
						Object.assign(item, registroAjustado);

					} catch (error) {
						errores++;
						console.error("Error ajustando registro:", error);
					}
				}
			}

			this.f_valor_ajustar(this.infoVigencia, this.infoSecuencia);

			if (errores === 0) {
				this.$toast.success(`Se ajustaron ${registrosAjustados} registros correctamente`);
			} else {
				this.$toast.warning(`Se ajustaron ${registrosAjustados} registros, con ${errores} errores`);
			}
			this.$emit('ajusteGuardado')
		},

		grabeAjuste() {
			let v_error = false
			if (this.v_ajuste_actual == "") {
				this.$toast.error("Diligenciar el campo Ajuste Actual")
				v_error = true
				return
			}
			if (!v_error) {
				this.showDialogEdit = false
				this.formEdit.ajuste_actual = this.v_ajuste_actual
				this.formEdit.ajuste_funcional1 = this.v_ajuste_funcional1
				this.formEdit.ajuste_promedio1 = this.v_ajuste_promedio1
				this.formEdit.ajuste_interna1 = this.v_ajuste_interna1
				this.formEdit.ajuste_funcional2 = this.v_ajuste_funcional2
				this.formEdit.ajuste_promedio2 = this.v_ajuste_promedio2
				this.formEdit.ajuste_interna2 = this.v_ajuste_interna2


				Balance.grabeAjuste("O", this.formEdit)
					.then(() => {
						this.f_valor_ajustar(this.infoVigencia, this.infoSecuencia)
						this.$toast.success("Informacion Grabada")

						// AÑADE ESTA LÍNEA PARA EMITIR EL EVENTO AL PADRE
						this.$emit('ajusteGuardado')
					})
					.catch(() => {
						this.$toast.error("Informacion no Grabada")
						this.error = true;
					});
			}
		},
		elimineAjuste() {
			this.showDialogEdit = false
			this.formEdit.ajuste_actual = this.v_ajuste_actual
			this.formEdit.ajuste_funcional1 = this.v_ajuste_funcional1

			Balance.elimineAjuste("O", this.formEdit)
				.then(() => {
					this.$toast.success("Informacion Grabada")
					// AÑADE ESTA LÍNEA PARA EMITIR EL EVENTO AL PADRE
					this.$emit('ajusteGuardado')
				})
				.catch(() => {
					this.$toast.error("Informacion no Grabada")
					this.error = true;
				});
		},
		async grabeContraAjuste() {
			try {
				// Si se selecciona origen y hay múltiples cuentas, aplicar distribución
				if (this.formAjuste.origen) {
					const cuentasOrigen = this.infoOrigen.filter(item => item.origen !== "C");

					if (cuentasOrigen.length > 1) {
						// Aplicar el ajuste a cada cuenta de origen
						for (const cuenta of cuentasOrigen) {
							const ajusteIndividual = {
								vigencia: cuenta.vigencia,
								secuencia: cuenta.secuencia,
								origen: "C",
								id_compania: cuenta.id_compania,
								tipo_ajuste: cuenta.tipo_ajuste,
								cuenta: 'CONCILIA',
								descripcion: this.formAjuste.descripcion,
								niif: cuenta.niif,
								saldo_actual: 0,
								funcional1: 0,
								promedio1: 0,
								interna1: 0,
								funcional2: 0,
								promedio2: 0,
								interna2: 0,
								ajuste_actual: this.v_ajuste_actual,
								ajuste_funcional1: this.v_ajuste_funcional1,
								ajuste_promedio1: this.v_ajuste_promedio1,
								ajuste_interna1: this.v_ajuste_interna1,
								ajuste_funcional2: this.v_ajuste_funcional2,
								ajuste_promedio2: this.v_ajuste_promedio2,
								ajuste_interna2: this.v_ajuste_interna2,
								u_crea: this.$store.state.userId
							};

							await Balance.grabeContraAjuste(ajusteIndividual);
						}

						this.$toast.success(`Ajuste distribuido en ${cuentasOrigen.length} cuentas`);

					} else {
						// Una sola cuenta, usar lógica original
						const r_ajuste = {
							vigencia: this.infoVigencia,
							secuencia: this.infoSecuencia,
							origen: "C",
							id_compania: this.infoIdCompania,
							tipo_ajuste: "O",
							cuenta: 'CONCILIA',
							descripcion: this.formAjuste.descripcion,
							niif: '',
							saldo_actual: 0,
							funcional1: 0,
							promedio1: 0,
							interna1: 0,
							funcional2: 0,
							promedio2: 0,
							interna2: 0,
							ajuste_actual: this.v_ajuste_actual,
							ajuste_funcional1: this.v_ajuste_funcional1,
							ajuste_promedio1: this.v_ajuste_promedio1,
							ajuste_interna1: this.v_ajuste_interna1,
							ajuste_funcional2: this.v_ajuste_funcional2,
							ajuste_promedio2: this.v_ajuste_promedio2,
							ajuste_interna2: this.v_ajuste_interna2,
							u_crea: this.$store.state.userId
						};

						await Balance.grabeContraAjuste(r_ajuste);
					}

				} else {
					// Destino - siempre una sola cuenta
					const r_ajuste = {
						vigencia: this.infoVigencia,
						secuencia: this.infoSecuencia,
						origen: "C",
						id_compania: this.infoIdCompania1,
						tipo_ajuste: "D",
						cuenta: 'CONCILIA',
						descripcion: this.formAjuste.descripcion,
						niif: '',
						saldo_actual: 0,
						funcional1: 0,
						promedio1: 0,
						interna1: 0,
						funcional2: 0,
						promedio2: 0,
						interna2: 0,
						ajuste_actual: this.v_ajuste_actual,
						ajuste_funcional1: this.v_ajuste_funcional1,
						ajuste_promedio1: this.v_ajuste_promedio1,
						ajuste_interna1: this.v_ajuste_interna1,
						ajuste_funcional2: this.v_ajuste_funcional2,
						ajuste_promedio2: this.v_ajuste_promedio2,
						ajuste_interna2: this.v_ajuste_interna2,
						u_crea: this.$store.state.userId
					};

					await Balance.grabeContraAjuste(r_ajuste);
				}

				// Actualizar datos
				this.f_valor_ajustar(this.infoVigencia, this.infoSecuencia);
				this.$toast.success("Ajuste aplicado correctamente");
				this.showContraAjuste = false;
				this.$emit('ajusteGuardado');

			} catch (error) {
				console.error("Error:", error);
				this.$toast.error("Error al aplicar el ajuste");
			}
		},
		f_valor_ajustar(vigencia, secuencia) {
			Balance.getValorAjustar(this.infocodReporte, vigencia, secuencia)
				.then((resultado) => {
					this.valor_ajustar_funcional1 = resultado.data.r_totales[0].valor_ajustar_funcional1
					this.valor_ajustar_promedio1 = resultado.data.r_totales[0].valor_ajustar_promedio1
					this.valor_ajustar_interna1 = resultado.data.r_totales[0].valor_ajustar_interna1
					this.valor_ajustar_funcional2 = resultado.data.r_totales[0].valor_ajustar_funcional2
					this.valor_ajustar_promedio2 = resultado.data.r_totales[0].valor_ajustar_promedio2
					this.valor_ajustar_interna2 = resultado.data.r_totales[0].valor_ajustar_interna2
				})
				.catch(() => {
					this.error = true;
				});
		},
		f_mostrar_diferencia() {
			this.f_valor_ajustar(this.infoVigencia, this.infoSecuencia)
			this.mostrar = !this.mostrar
		},
		f_contraAjuste() {
			let totalOrigen = 0;
			this.infoOrigen.forEach(item => {
				if (item.origen !== "C") {
					totalOrigen += parseFloat(item.ajuste_funcional1) || 0;
				}
			});

			let totalDestino = 0;
			if (this.$parent && this.$parent.listDestino) {
				this.$parent.listDestino.forEach(item => {
					if (item.origen !== "C") {
						totalDestino += parseFloat(item.ajuste_funcional1) || 0;
					}
				});
			}

			this.diferenciaTotal = -(totalOrigen + totalDestino);

			this.cuentasOrigen = this.infoOrigen.filter(item => item.origen !== "C").length;

			console.log("Cálculo balanceo:", {
				totalOrigen: totalOrigen,
				totalDestino: totalDestino,
				sumaTotal: totalOrigen + totalDestino,
				diferenciaTotal: this.diferenciaTotal,
				cuentasOrigen: this.cuentasOrigen
			});

			this.formAjuste.origen = true;
			this.formAjuste.destino = false;
			this.formAjuste.descripcion = "AJUSTE CONCILIACION AUTOMÁTICO";
			this.showSummary = true;

			if (Math.abs(this.diferenciaTotal) > 0.01) {
				this.showContraAjuste = true;
			} else {
				this.$toast.info("No hay diferencia para ajustar (la suma ya es 0)");
			}
		},

		toggleDetalle() {
			this.fgl_detalle = !this.fgl_detalle;
		},

		async aplicarAjusteAutomatico() {
			console.log("Aplicando ajuste con diferenciaTotal:", this.diferenciaTotal);

			if (Math.abs(this.diferenciaTotal) < 0.01) {
				this.$toast.info("No hay diferencia para ajustar");
				this.showContraAjuste = false;
				return;
			}

			try {
				if (this.formAjuste.origen) {

					const cuentasAjustables = this.infoOrigen.filter(item => item.origen !== "C");

					if (cuentasAjustables.length === 0) {
						this.$toast.error("No hay cuentas de origen para ajustar");
						return;
					}

					const valorPorCuenta = this.diferenciaTotal / cuentasAjustables.length;

					console.log(`Distribuyendo ${this.formato(this.diferenciaTotal)} entre ${cuentasAjustables.length} cuentas del ORIGEN`);
					console.log(`Valor por cuenta: ${this.formato(valorPorCuenta)}`);

					for (const cuenta of cuentasAjustables) {

						const nuevoAjuste = valorPorCuenta;

						await Balance.grabeAjuste("O", {
							vigencia: cuenta.vigencia,
							secuencia: cuenta.secuencia,
							id_compania: cuenta.id_compania,
							cuenta: cuenta.cuenta,
							origen: cuenta.origen,
							tipo_ajuste: cuenta.tipo_ajuste,
							ajuste_actual: nuevoAjuste,
							ajuste_funcional1: nuevoAjuste,
							ajuste_promedio1: nuevoAjuste,
							ajuste_interna1: nuevoAjuste,
							ajuste_funcional2: nuevoAjuste,
							ajuste_promedio2: nuevoAjuste,
							ajuste_interna2: nuevoAjuste
						});

						console.log(`Cuenta ${cuenta.cuenta}: ajuste_funcional1 = ${this.formato(nuevoAjuste)}`);
					}

					this.$toast.success(`Ajuste distribuido equitativamente en ${cuentasAjustables.length} cuentas del ORIGEN`);

				} else if (this.formAjuste.destino) {

					if (!this.$parent || !this.$parent.listDestino) {
						this.$toast.error("No hay cuentas de destino disponibles");
						return;
					}

					const cuentasAjustables = this.$parent.listDestino.filter(item => item.origen !== "C");

					if (cuentasAjustables.length === 0) {
						this.$toast.error("No hay cuentas de destino para ajustar");
						return;
					}

					const valorPorCuenta = this.diferenciaTotal / cuentasAjustables.length;

					console.log(`Distribuyendo ${this.formato(this.diferenciaTotal)} entre ${cuentasAjustables.length} cuentas del DESTINO`);
					console.log(`Valor por cuenta: ${this.formato(valorPorCuenta)}`);

					for (const cuenta of cuentasAjustables) {
						const nuevoAjuste = valorPorCuenta;

						await Balance.grabeAjuste("D", {
							vigencia: cuenta.vigencia,
							secuencia: cuenta.secuencia,
							id_compania: cuenta.id_compania,
							cuenta: cuenta.cuenta,
							origen: cuenta.origen,
							tipo_ajuste: cuenta.tipo_ajuste,
							ajuste_actual: nuevoAjuste,
							ajuste_funcional1: nuevoAjuste,
							ajuste_promedio1: nuevoAjuste,
							ajuste_interna1: nuevoAjuste,
							ajuste_funcional2: nuevoAjuste,
							ajuste_promedio2: nuevoAjuste,
							ajuste_interna2: nuevoAjuste
						});

						console.log(`Cuenta destino ${cuenta.cuenta}: ajuste_funcional1 = ${this.formato(nuevoAjuste)}`);
					}

					this.$toast.success(`Ajuste distribuido equitativamente en ${cuentasAjustables.length} cuentas del DESTINO`);
				}

				this.showContraAjuste = false;
				this.f_valor_ajustar(this.infoVigencia, this.infoSecuencia);
				this.$emit('ajusteGuardado');

			} catch (error) {
				console.error("Error en aplicarAjusteAutomatico:", error);
				this.$toast.error("Error al aplicar el ajuste automático");
			}
		},

		uncheck(opcion) {
			this.formAjuste.origen = false;
			this.formAjuste.destino = false;

			if (opcion === 1) {
				this.formAjuste.origen = true;
			} else {
				this.formAjuste.destino = true;
			}
		}
	},
	mounted() {
		this.f_valor_ajustar(this.infoVigencia, this.infoSecuencia)
	},
	watch: {
		infoOrigen: {
			immediate: true,
			handler(nuevoValor) {
				if (nuevoValor && nuevoValor.length > 0) {
					this.datosOrigen = [...nuevoValor];
				}
			}
		},
		optOrigen(Origen) {
			this.$emit('envOrigen', Origen)
		}
	}
};
</script>

<style scoped>
.balance-table {
    font-size: 13px;
    width: 100% !important;
}

.principal-table>>>.md-table {
    table-layout: auto !important;
    width: max-content !important;
}

.principal-table>>>.md-table-cell {
    white-space: nowrap !important;
    padding: 8px 12px !important;
}

.principal-table>>>.md-table-cell:nth-child(2) {
    width: 200px !important;
    min-width: 200px !important;
    max-width: 220px !important;
    white-space: nowrap !important;
}

.principal-table>>>.md-table-cell:not(:nth-child(2)) {
    width: 50px !important;
    min-width: 50px !important;
    max-width: 50px !important;
}

.bodyOrigen {
    width: 100%;
    overflow-x: auto !important;
}

.principal-table>>>.md-table-cell.text-right {
    max-width: 130px !important;
}

.number-cell, .text-right {
    white-space: nowrap !important;
}

/* Estilos condicionales para cuando se muestra detalle */
.principal-table.with-detail>>>.md-table-cell {
    min-width: 100px !important;
}

.balance-table>>>.md-table-head {
    padding: 4px 6px !important;
    font-size: 12px !important;
}

.clickable-row {
    cursor: pointer;
    transition: background-color 0.2s;
}

.clickable-row:hover {
    background-color: #f5f5f5 !important;
}

.border {
    border: 1px solid #dee2e6 !important;
}

/* Forzar reflow al cambiar detalle */
.principal-table {
    min-width: 100% !important;
}

.button-group-sobrio {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    margin: 20px 0;
}

.action-btn-sobrio {
    min-width: 120px;
    border-radius: 6px;
    text-transform: none;
    font-weight: 500;
    transition: all 0.3s ease;
}

.action-btn-sobrio .md-icon {
    margin-right: 8px;
}

.action-btn-sobrio:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.action-buttons-sobrios {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px 0;
}

@media (max-width: 768px) {
    .button-group-sobrio {
        flex-direction: column;
        align-items: stretch;
    }
    
    .action-btn-sobrio {
        min-width: auto;
    }
}
</style>
